export function AuroraBackground() {
  return null;
}
